import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import { useItemCompaniesStore } from '@/stores/dictionary/item-companies';
import { ItemCompanyResource } from '@shared/resources/item-company';
import { computed } from 'vue';

interface Emits {
  (e: 'update:modelValue', value?: ItemCompanyResource): void;
}
interface Props {
  modelValue?: ItemCompanyResource;
  hideEmpty?: boolean;
  disabled?: boolean;
  small?: boolean;
  dropdownHeight?: number;
  errors?: string|string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ItemCompanySelect',
  props: {
    modelValue: null,
    hideEmpty: { type: Boolean },
    disabled: { type: Boolean },
    small: { type: Boolean },
    dropdownHeight: null,
    errors: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value?: ItemCompanyResource): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: ItemCompanyResource;
  hideEmpty?: boolean;
  disabled?: boolean;
  small?: boolean;
  dropdownHeight?: number;
  errors?: string|string[];
}

const itemCompaniesStore = useItemCompaniesStore();





const selectManager = useSelectClientDataManager({
  data: computed(() => itemCompaniesStore.data),
  searchBy: ['name'],
  selected: computed(() => props.modelValue),
  hideSelected: true,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SingleSelect), {
    "data-manager": _unref(selectManager),
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
    "select-option-text": _ctx.$t('pages.common.select-item-company'),
    "hide-empty": __props.hideEmpty,
    disabled: __props.disabled,
    small: __props.small,
    errors: __props.errors,
    "dropdown-height": __props.dropdownHeight
  }, null, 8, ["data-manager", "model-value", "select-option-text", "hide-empty", "disabled", "small", "errors", "dropdown-height"]))
}
}

})